/**
 * Created by Oles on 4/27/2017.
 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../actions/index';
import TestDetailsWndController from './TestDetailsWndController.jsx';
import TestResultRowController from './TestResultRowController.jsx';
import PropTypes from 'prop-types';
import TestResultsMessageBoxController from "./TestResultsMessageBoxController.jsx";
import TestResultsTableHeader from "./TestResultsTableHeader.jsx";
import { getTestAttributes } from '@common/utils/tests';
import { Button } from '@common/components/Button';
import { CustomPanel } from '../components/custom-panel';
import { createPanel, updatePanel, createPanelFolder, deletePanel, deletePanelFolder, getPanels, getPanelsFolders, getPanelFormat, getPanelsFlat, doesPanelNameExist, overwritePanel } from '../actions/panels';
import { getLabs } from '../actions';
import { Flex } from '@common/components/Flex';

class TestResultsApp extends Component {
    moduleName = 'TestResults';

    state = {
        customPanelProps: {
            opened: false,
        },
    };

    constructor(props) {
        super(props);
        
        this.props.loadResults();
    }

    openNewCustomPanel = () => {
        this.props.getAndSetGenes();
        this.setState((x) => ({
            ...x,
            customPanelProps: {
                opened: true,
                mode: 'create'
            }
        }));
    }

    closeCustomPanel = () => {
        this.setState((x) => ({
            ...x,
            customPanelProps: {
                opened: false,
            }
        }));
        this.props.resetGenes();
    }

    openLoadCustomPanel = () => {
        this.props.getAndSetGenes();
        this.setState((x) => ({
            ...x,
            customPanelProps: {
                opened: true,
                mode: 'edit'
            }
        }));
    }

    handlePanelCreate = async (panel) => {
        await createPanel(panel);
        this.closeCustomPanel();
    }

    handlePanelOverwrite = async (panel) => {
        await overwritePanel(panel);
        this.closeCustomPanel();
    }

    handlePanelUpdate = async (panel) => {
        await updatePanel(panel);
        this.closeCustomPanel();
    }

    render () {
        const I18n = require('react-redux-i18n').I18n;
        var clientWidth = window.innerWidth;
        const rows = this.props.tests.map(row => {
            return <TestResultRowController key={row.id} row={row}/>
        });
        this.props.testResultsColumnWidths.forEach(function(column) { //i18n for the column headers
            var translationKey = column.title.replace(' ', '');
            translationKey = translationKey.charAt(0).toLowerCase() + translationKey.slice(1);
            column.title = I18n.t(translationKey);
        });

        return  (
            <div className="container" style={{width: '100%', marginLeft: '15px'}}>
                {this.state.customPanelProps.opened && (
                    <CustomPanel
                        doesPanelNameExist={doesPanelNameExist}
                        onCreate={this.handlePanelCreate}
                        onOverwrite={this.handlePanelOverwrite}
                        onUpdate={this.handlePanelUpdate}
                        mode={this.state.customPanelProps.mode || "create"}
                        genes={this.props.currentTest?.genes}
                        deletePanel={deletePanel}
                        getPanels={(folderId) => (getPanels(folderId)).then((res) => res.map((panelFormat) => ({ id: panelFormat.id, name: panelFormat.formatname })))}
                        deletePanelFolder={deletePanelFolder}
                        createFolder={createPanelFolder}
                        close={this.closeCustomPanel} 
                        getFolders={getPanelsFolders}
                        getPanelFormat={getPanelFormat}
                        getLabs={getLabs}
                        onGenesLoad={this.props.updateInitialGenes}
                    />
                )}
                
                <div className="row">
                    <div className="col-md-12" style={{paddingTop: '10px', paddingBottom: '5px', paddingLeft: '0px'}}>
                        <div style={{color: '#008dce', fontSize: '22px', float: 'left', letterSpacing: '-0.5px'}}>
                            {I18n.t('testResultsFor')}{this.props.name}
                        </div>
                    </div>
                    <Flex justify="flex-end" className="col-md-12" style={{paddingTop: '0px', paddingBottom: '11px'}}>
                        <Button
                            {...getTestAttributes(this.moduleName, 'load-custom-panel', 'btn')}
                            bsStyle="primary"
                            style={{ marginRight: '20px'}}
                            onClick={this.openLoadCustomPanel}
                        >
                            {I18n.t('Load Custom Panel')}
                        </Button>
                        <Button
                            {...getTestAttributes(this.moduleName, 'new-custom-panel', 'btn')}
                            bsStyle="primary"
                            style={{ marginRight: '20px'}}
                            onClick={this.openNewCustomPanel}
                        >
                            <i className="fa fa-plus" aria-hidden="true" style={{paddingRight: '5px'}}></i>
                            {I18n.t('New Custom Panel')}
                        </Button>
                        <button
                            id="btn-new-test"
                            className="btn btn-primary"
                            style={{float: 'right', marginRight: '20px'}}
                            onClick={this.props.showTestDetailsWnd}
                        >
                            <i className="fa fa-plus" aria-hidden="true" style={{paddingRight: '5px'}}></i>
                            {I18n.t('newTest')}
                        </button>
                    </Flex>
                </div>
                <div className="row" style={{ height: 'calc(100vh - 180px)' }}>
                    <div style={{overflowX: 'auto', width: clientWidth - 15 + 'px', height: '100%', overflowY: 'hidden'}}>
                        <table className="table table-striped" style={{backgroundColor: '#f5f5f5', height: '100%', display: 'block'}}>
                            <TestResultsTableHeader columns={this.props.testResultsColumnWidths}/>
                            <tbody style={{height: 'calc(100% - 35px)', display: 'block', overflow: 'auto'}}>
                                {rows}
                            </tbody>
                        </table>
                        {rows.length == 0 &&
                            <span style={{
                                fontSize: 15 + 'px',
                                fontFamily: 'Roboto',
                                color: '#aaaaaa',
                                display: 'block',
                                marginTop: 45 + 'px',
                                textAlign: 'center'
                            }}>
                                {I18n.t('noResults')}
                            </span>
                        }
                        <div style={{width: '100%', height: '45px'}}></div>
                    </div>
                </div>
                <TestDetailsWndController show={this.props.showTestDetails} />
                <TestResultsMessageBoxController />
            </div>
        );
    }
}

TestResultsApp.PropTypes = {
    name: PropTypes.string,
    tests: PropTypes.arrayOf(PropTypes.object),
    showTestDetails: PropTypes.bool,
    loadResults: PropTypes.func,
    showTestDetailsWnd: PropTypes.func
};

const mapStateToProps = state => {
    return {
        currentTest: state.testDetails.test,
        name: state.patient.name,
        tests: state.tests,
        showTestDetails: state.testDetails.show,
        testResultsColumnWidths: state.testColumns
    }
};

const mapDispatchToProps = dispatch => {
    return {
        resetGenes: () => dispatch(actions.resetGenes()),
        getAndSetGenes: () => dispatch(actions.getAndSetGenes()),
        loadResults: () => {
                            dispatch(actions.loginToAmbry())
                           },
		showTestDetailsWnd: () => dispatch(actions.showTestDetails(true)),
        updateInitialGenes: (genes) => dispatch(actions.updateInitialGenes(genes)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(TestResultsApp);